import SilverCoinSvg from "./SilverCoinSvg";

export default SilverCoinSvg;

export { SilverCoinSvg };
